var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap my-3",staticStyle:{"gap":"15px"}},_vm._l((_vm.labels),function(label){return _c('div',{key:label.color,staticClass:"color-wrapper"},[_c('div',{staticClass:"color-box",style:(`background: ${label.color}`)}),_vm._v(" "+_vm._s(label.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }